import React, { useState } from "react";
import { completeMandatoryBanquetOwnerPasswordChange, logoutBanquetOwner } from "../services/banquetOwnerAuthService.js";

const inputClassName =
  "w-full rounded-2xl border border-slate-200 bg-white px-4 py-3 text-sm text-slate-700 outline-none transition focus:border-emerald-500 focus:ring-2 focus:ring-emerald-100";

export default function ChangePasswordScreen({ onPasswordChanged }) {
  const [formState, setFormState] = useState({ newPassword: "", confirmPassword: "" });
  const [status, setStatus] = useState({ isSubmitting: false, error: "" });

  const updateField = (key, value) =>
    setFormState((current) => ({
      ...current,
      [key]: value,
    }));

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (formState.newPassword !== formState.confirmPassword) {
      setStatus({ isSubmitting: false, error: "Passwords do not match." });
      return;
    }

    setStatus({ isSubmitting: true, error: "" });

    try {
      await completeMandatoryBanquetOwnerPasswordChange({ newPassword: formState.newPassword });
      onPasswordChanged?.();
    } catch (error) {
      setStatus({ isSubmitting: false, error: error.message || "Unable to change password." });
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#f5f7f4] px-4">
      <div className="w-full max-w-md rounded-3xl border border-slate-200 bg-white p-8 shadow-sm">
        <p className="text-xs font-semibold uppercase tracking-[0.24em] text-emerald-600">Security Step Required</p>
        <h1 className="mt-3 text-2xl font-semibold text-slate-900">Set a new password</h1>
        <p className="mt-2 text-sm text-slate-600">
          This is your first login with a temporary password. Please set a new password before continuing.
        </p>

        <form className="mt-6 space-y-4" onSubmit={handleSubmit}>
          <div>
            <label className="mb-1.5 block text-[11px] font-semibold uppercase tracking-[0.18em] text-slate-500">
              New Password
            </label>
            <input
              type="password"
              value={formState.newPassword}
              onChange={(event) => updateField("newPassword", event.target.value)}
              className={inputClassName}
              placeholder="At least 6 characters"
              autoComplete="new-password"
            />
          </div>

          <div>
            <label className="mb-1.5 block text-[11px] font-semibold uppercase tracking-[0.18em] text-slate-500">
              Confirm New Password
            </label>
            <input
              type="password"
              value={formState.confirmPassword}
              onChange={(event) => updateField("confirmPassword", event.target.value)}
              className={inputClassName}
              placeholder="Re-enter new password"
              autoComplete="new-password"
            />
          </div>

          {status.error ? (
            <div className="rounded-2xl border border-rose-200 bg-rose-50 px-4 py-3 text-sm text-rose-700">
              {status.error}
            </div>
          ) : null}

          <button
            type="submit"
            disabled={status.isSubmitting}
            className="inline-flex w-full items-center justify-center rounded-2xl bg-emerald-600 px-5 py-3 text-sm font-semibold text-white transition hover:bg-emerald-700 disabled:cursor-not-allowed disabled:opacity-70"
          >
            {status.isSubmitting ? "Saving..." : "Set New Password"}
          </button>

          <button
            type="button"
            disabled={status.isSubmitting}
            onClick={() => logoutBanquetOwner()}
            className="inline-flex w-full items-center justify-center rounded-2xl border border-slate-300 px-5 py-3 text-sm font-semibold text-slate-700 transition hover:bg-slate-50 disabled:cursor-not-allowed disabled:opacity-70"
          >
            Logout
          </button>
        </form>
      </div>
    </div>
  );
}
